
import { BoardCategory } from '@/types/board';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface CategorySelectorProps {
  value: BoardCategory;
  onChange: (value: BoardCategory) => void;
  categories: BoardCategory[];
}

const CategorySelector = ({ value, onChange, categories }: CategorySelectorProps) => {
  return (
    <div className="space-y-2">
      <label htmlFor="category" className="block text-sm font-medium">
        카테고리
      </label>
      <Select 
        value={value} 
        onValueChange={(value) => onChange(value as BoardCategory)}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="카테고리 선택" />
        </SelectTrigger>
        <SelectContent>
          {categories.map((cat) => (
            <SelectItem key={cat} value={cat}>
              {cat}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CategorySelector;
